import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';
import { TidalInfoTag } from '../../common/tag';
import Back from '../../svgs/Back';
import Settings from '../../svgs/Settings';

const TidalDashboardHeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  position: sticky;
  background-color: ${(props) => props.theme.colors.background};
  top: 0;
  z-index: 20;
`;

export const TidalDashboardHeaderBackButton = styled.button`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-gap: 0 8px;
  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    color: #9da3b7;
  }
`;

const TidalDashboardHeaderContainer = styled.div`
  display: flex;
  .header-title {
    font-size: 24px;
    line-height: 29px;
    color: ${(props) => props.theme.colors.text[2]};
    font-weight: bold;
    @media only screen and (max-width: 580px) {
      font-size: 18px;
    }
  }
`;

const TidalDashboardHeaderChipRow = styled.div`
  display: flex;
  align-items: center;
  margin-left: 14px;
  grid-gap: 0 8px;
  & div {
    cursor: pointer;
  }
`;

const TidalDashboardHeaderSettingsContainer = styled.button`
  display: flex;
  align-items: center;
  grid-gap: 5px;

  p {
    color: ${(props) => props.theme.colors.text[0]};
    font-size: 14px;
    font-weight: 600;
    @media only screen and (max-width: 580px) {
      display: none;
    }
  }
`;

interface ITidalDashboardHeader {
  title: string;
  showSettings?: boolean;
  tags: any[];
  hasBackButton?: boolean;
  onTagClick?: (index: number) => void;
  onSettingsClick?: () => void;
}

const TidalDashboardHeader = ({
  title,
  showSettings,
  tags,
  hasBackButton,
  onTagClick,
  onSettingsClick,
}: ITidalDashboardHeader): JSX.Element => {
  const router = useRouter();
  return (
    <>
      {hasBackButton && (
        <TidalDashboardHeaderBackButton
          onClick={() => {
            router.back();
          }}
        >
          <Back />
          <p>Go back</p>
        </TidalDashboardHeaderBackButton>
      )}
      <TidalDashboardHeaderWrapper className="pt-0 md:pt-3 pb-1 md:pb-3">
        <TidalDashboardHeaderContainer>
          <p className="header-title">{title}</p>
          <TidalDashboardHeaderChipRow>
            {tags.map((tag, index) => (
              <div key={index} onClick={() => onTagClick(index)}>
                <TidalInfoTag text={tag.text} isActive={tag.isActive} />
              </div>
            ))}
          </TidalDashboardHeaderChipRow>
        </TidalDashboardHeaderContainer>
        {showSettings && (
          <TidalDashboardHeaderSettingsContainer onClick={onSettingsClick}>
            <Settings color="#9DA3B7" />
            <p>Settings</p>
          </TidalDashboardHeaderSettingsContainer>
        )}
      </TidalDashboardHeaderWrapper>
    </>
  );
};

export default TidalDashboardHeader;
